module.exports = __webpack_public_path__ + "img/icon_map_199_off_001.36c8a414.png";